import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { Box } from '@mui/material';
import moment from 'moment';
import toast from 'react-hot-toast';
import Slider from "react-slick";

import CustomButton from '../../../common/CustomButton';
import CustomInputV2 from '../../../common/CustomInputV2';
import CustomActionButton from '../../../common/CustomActionButton';

import { UpdateUserToList, RemoveUserToList } from '../../../redux/user/actions';
import { apiCallV2 } from '../../../utils/api'

const EditUser = (props) => {
    const { user, data, setData, setShow } = props;

    const [userState, setUserState] = useState({
        table_id: '',
        first_name: '',
        last_name: '',
        email_address: '',
        dob: null,
        mobile_number: ''
    })

    const [errors, setErrors] = useState({
        first_name: false,
        last_name: false,
        email_address: false,
        dob: false,
        mobile_number: false
    })

    //Slick slider
    const sliderRef = useRef(null);
    const [slide, setSlide] = useState(0);
    const settings = {
        rows: 1,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        swipeToSlide: true,
        swipe: false,
        arrows: false,
        draggable: false,
        initialSlide: slide,
        adaptiveHeight: true,
    };
    const SlideTo = (p) => {
        sliderRef?.current?.slickGoTo(p);
    }

    // states used for EditUserAutoComplete
    const [selectedOption, setSelectedOption] = useState('');

    // states for checkboxes
    const [checkBoxStatus, setCheckBoxStatus] = useState({
        updateForm: false,
        expireUser: false,
    })
    // 

    // Inputs onchange
    const handleChange = (e) => {
        setUserState({ ...userState, [e.target.name]: e.target.value })
    }

    const validateNeedUpdate = () => {
        let userObjToCompare = {
            table_id: user?.table_id,
            first_name: user?.first_name,
            last_name: user?.last_name,
            email_address: user?.email_address,
            dob: user?.dob,
            mobile_number: user?.mobile_number
        }

        if (JSON.stringify(userObjToCompare) === JSON.stringify(userState)) {
            return 0
        }
    }

    const validateInputs = () => {
        let flag = false
        if (!userState.first_name) {
            flag = true
        }
        if (!userState.last_name) {
            flag = true
        }
        if (!userState.email_address) {
            flag = true
        }
        return flag
    }

    const handleConfirmUpdateUser = async () => {
        setErrors({
            first_name: false,
            last_name: false,
            email_address: false,
            dob: false,
            mobile_number: false
        })
        let needUpdateValidator = validateNeedUpdate()
        if (needUpdateValidator === 0) {
            toast.error('Nothing to update!')
            return false;
        }
        let isIncomplete = validateInputs()
        if (isIncomplete) {
            toast.error('Please check required inputs!')
            return false;
        }

        const res = await apiCallV2("POST", "admin/user/update-user", { ...userState, userID: user.userID }, localStorage.getItem("access-token"));
        if (res.data.status === 200) {
            toast.success('User updated!')
            props.UpdateUserToList(user, {
                first_name: userState?.first_name,
                last_name: userState?.last_name,
                dob: userState?.dob,
                email_address: userState?.email_address,
                mobile_number: userState?.mobile_number,
            });
            setShow(false)
            return true;
        }
        if (res.data.status === 500) {
            toast.error(res.data.message)
            return false;
        }
    }

    const handleConfirmExpireUser = async () => {
        const res = await apiCallV2("POST", "admin/user/expire-user", user, localStorage.getItem("access-token"));
        if (res.data.status === 200) {
            toast.success('User status set to expired!')
            props.RemoveUserToList(user);
            setShow(false)
            return true;
        }
        if (res.data.status === 500) {
            toast.error(res.data.message)
            return false;
        }
    }

    useEffect(() => {
        // get the dob start
        let dobDate = new Date(user?.dob)
        let day = dobDate.getDate();
        let month = ('0' + (dobDate.getMonth() + 1)).slice(-2)
        let year = dobDate.getFullYear();
        let currentDate = `${year}-${month}-${day}`;
        // get the dob end

        setUserState({
            table_id: user?.table_id,
            first_name: user?.first_name,
            last_name: user?.last_name,
            email_address: user?.email_address,
            dob: user?.dob ? currentDate : null,
            mobile_number: user?.mobile_number
        })
    }, [user])

    return (

        <div id="edit-user-form">
            <Box sx={{ mb: '30px' }}>


                <div id="euf-header">
                    <p>
                        {(user?.first_name + " " + user?.last_name).toUpperCase()} - DOB: {user?.dob ? moment(user?.dob).format('MMM-DD-YYYY') : ''}
                    </p>
                    <p>{user?.name || "NO COMPANY"}</p>
                </div>

                <div className='euf-slick-container'>
                    <Slider {...settings} ref={sliderRef}>
                        <div>

                            <div>
                                <div id="option-card-list">
                                    <div id="option-card" onClick={() => {
                                        setSelectedOption(selectedOption == 'update' ? "" : 'update');
                                    }}>
                                        <div class={"op-indicator " + (selectedOption == "update" ? "selected" : "")}></div>
                                        <h5>Update User</h5>
                                    </div>

                                    <div id="option-card" onClick={() => {
                                        setSelectedOption(selectedOption == 'expire' ? "" : 'expire');
                                    }}>
                                        <div class={"op-indicator " + (selectedOption == "expire" ? "selected" : "")}></div>
                                        <h5>Expire User</h5>
                                    </div>
                                </div>

                                <div className='edit-su-action'>
                                    {
                                        selectedOption === 'update'
                                            ? <>
                                                <CustomButton onClick={() => {
                                                    SlideTo(1);
                                                }}>UPDATE</CustomButton>
                                            </>
                                            : <>
                                                <CustomActionButton action={handleConfirmExpireUser}>EXPIRE</CustomActionButton>
                                            </>
                                    }
                                </div>

                            </div>

                        </div>

                        <div>
                            <form>
                                <div className='euf-form-container'>
                                    <div id='euf-form-inputs'>
                                        <CustomInputV2 placeholder="first name" required={true} value={userState?.first_name} name="first_name" onChange={handleChange} error={errors.first_name} />
                                        <CustomInputV2 placeholder="last name" required={true} value={userState?.last_name} name="last_name" onChange={handleChange} error={errors.last_name} />
                                        <CustomInputV2 placeholder="email" required={true} value={userState?.email_address} name="email_address" onChange={handleChange} error={errors.email_address} />
                                        <CustomInputV2 type="date" value={userState?.dob} name="dob" onChange={handleChange} error={errors.dob} />
                                        <CustomInputV2 placeholder="mobile No" value={userState?.mobile_number} name="mobile_number" onChange={handleChange} error={errors.mobile_number} />
                                    </div>
                                    <div className='euf-action'>
                                        <CustomButton isPrimary={false} onClick={() => { SlideTo(0) }}>BACK</CustomButton>
                                        <CustomActionButton action={handleConfirmUpdateUser}>UPDATE</CustomActionButton>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </Slider>
                </div>
            </Box>
        </div>

    );
};

const mapStateToProps = (state) => ({
})

export default connect(mapStateToProps, {
    UpdateUserToList,
    RemoveUserToList,
})(EditUser);
